import InstagramIcon from '@/assets/IG-socmed-icon.svg?react'
import FacebookIcon from '@/assets/FB-socmed-icon.svg?react'
import TwitterIcon from '@/assets/Twitter-socmed-icon.svg?react'
import YoutubeIcon from '@/assets/Youtube-socmed-icon.svg?react'
import TiktokIcon from '@/assets/Tiktok-socmed-icon.svg?react'

interface SocmedIconProps {
  socialMedia: string
}

const SocmedIcon = ({ socialMedia }: SocmedIconProps) => {
  switch (socialMedia) {
    case 'instagram':
      return <InstagramIcon />
    case 'facebook':
      return <FacebookIcon />
    case 'twitter':
      return <TwitterIcon />
    case 'youtube':
      return <YoutubeIcon />
    case 'tiktok':
      return <TiktokIcon />
    default:
      break
  }
}

export default SocmedIcon
